module.exports = __webpack_public_path__ + "img/3-4.2480ae4.png";